import {cdnImage} from '@/util/cdnImage';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import dynamic from 'next/dynamic';
import React from 'react';

// ─── getStaticProps ─────────────────────────────────────────────────────────
export const getStaticProps = async () => {
    const {
        bep20IndustryData,
        bep20TokenBannerPoint,
        bep20TokenChooseBody,
        bep20TokenChooseContent,
        bep20TokenMobileProcess,
        bep20TokenTechnologyData,
        diverseTokenContent,
        diverseTokenDevelopment,
        featureDevelopmentContent,
        keyBenefitTokenDevelopmentContent,
        NFTGeniusCheckPoints,
        NFTGeniusScreenButton,
        tokenCompanyBannerBottom,
        tokenCompanyDecodingData,
        tokenCompanyFAQData,
        tokenCompanyFeatureContent,
        TokenCraftCheckPoints,
        TokenCraftScreenButton,
        tokenDevelopmentCarsoulData,
        tokenDevelopmentData,
        TokenGeniusCheckPoints,
        TokenGeniusScreenButton
    } = await import('@/util/contents/token-development-company');

    return {
        props: {
            bep20IndustryData,
            bep20TokenBannerPoint,
            bep20TokenChooseBody,
            bep20TokenChooseContent,
            bep20TokenMobileProcess,
            bep20TokenTechnologyData,
            diverseTokenContent,
            diverseTokenDevelopment,
            featureDevelopmentContent,
            keyBenefitTokenDevelopmentContent,
            NFTGeniusCheckPoints,
            NFTGeniusScreenButton,
            tokenCompanyBannerBottom,
            tokenCompanyDecodingData,
            tokenCompanyFAQData,
            tokenCompanyFeatureContent,
            TokenCraftCheckPoints,
            TokenCraftScreenButton,
            tokenDevelopmentCarsoulData,
            tokenDevelopmentData,
            TokenGeniusCheckPoints,
            TokenGeniusScreenButton
        }
    };
};

const Banner = dynamic(() => import('@/components/Ui-components/Banner'));
const DisplayImage = dynamic(() => import('@/components/Ui-components/display-image'));
const Decoding = dynamic(() => import('@/components/Ui-components/Decoding'));
const driving = cdnImage('BEP-20/BEP20-Token-Development.webp');
import {MUIContainer} from '@/components/MUI-Components';
const HelperSection = dynamic(() => import('@/components/Ui-components/helper-section'));
import PageHead from '@/components/PageHead';
import {BEP20_TOKEN_DEVELOPMENT} from '@/util/metaData/crypto';
import {CDN_URL, SITE_URL} from '@/constants/urls';
const DynamicScreens = dynamic(() => import('@/components/Ui-components/Dynamic-screens'));
const Platforms = dynamic(() => import('@/components/Ui-components/platforms'));
const OurServices = dynamic(() => import('@/components/Ui-components/our-services'));
const Questions = dynamic(import('@/components/Ui-components/questions'));
const Testimonials = dynamic(import('@/components/Ui-components/Testimonials'));
const LetDiscuss = dynamic(() => import('@/components/Ui-components/Lets-discuss'));
const genius = cdnImage('BEP-20/TokenGenius-Platform.webp');
const tokenCraft = cdnImage('BEP-20/TokenCraft-Platform.webp');
const nftGenius = cdnImage('BEP-20/NFTGenius.webp');
const LatestCTA = dynamic(() => import('@/components/Ui-components/LatestCta'));
const TokenizeHelp = dynamic(() => import('@/components/Ui-components/tokenize-help'));
const CardTechnology = dynamic(() => import('@/components/Ui-components/card-technology'));
const MobileProcess = dynamic(() => import('@/components/Ui-components/MobileProcess'));
const development = cdnImage('BEP-20/BEP-20-Token-Development-Process.svg');
const OurMakeChoice = dynamic(() => import('@/components/Ui-components/OurMakeChoice'));

const TokenDevelopment = (props: any) => {
    const {
        openForm,
        bep20IndustryData,
        bep20TokenBannerPoint,
        bep20TokenChooseBody,
        bep20TokenChooseContent,
        bep20TokenMobileProcess,
        bep20TokenTechnologyData,
        diverseTokenContent,
        diverseTokenDevelopment,
        featureDevelopmentContent,
        keyBenefitTokenDevelopmentContent,
        NFTGeniusCheckPoints,
        NFTGeniusScreenButton,
        tokenCompanyBannerBottom,
        tokenCompanyDecodingData,
        tokenCompanyFAQData,
        tokenCompanyFeatureContent,
        TokenCraftCheckPoints,
        TokenCraftScreenButton,
        tokenDevelopmentCarsoulData,
        tokenDevelopmentData,
        TokenGeniusCheckPoints,
        TokenGeniusScreenButton
    } = props;
    const TokenGeniusData = [
        'TokenGenius, a leading blockchain startup, needed an efficient and secure platform for seamless token development and successful ICO campaigns. Debut Infotech developed a comprehensive solution using Ethereum and smart contracts to facilitate secure token creation, manage ICO campaigns, and ensure regulatory compliance. This platform attracted investors, reduced development time, and enhanced trust in the ICO process.'
    ];
    const TokenCraftData = [
        "TokenCraft, an emerging blockchain startup, aimed to build credibility in a competitive ICO market. Debut Infotech developed a platform leveraging Ethereum smart contracts to enhance transparency in token creation and ensure compliance with evolving regulations. The solution included investor engagement tools and a comprehensive compliance framework, differentiating TokenCraft's ICO campaigns and increasing investor trust."
    ];

    const NFTGeniusData = [
        'NFTGenius, a pioneering NFT platform, sought to redefine NFT creation and trading. Debut Infotech developed a robust platform using Ethereum, IPFS, and smart contracts to enable creators to mint and trade NFTs securely. The platform featured a decentralized marketplace, advanced security measures, and a user-friendly interface, empowering creators and engaging collectors in a vibrant ecosystem.'
    ];
    return (
        <Box>
            <PageHead meta={BEP20_TOKEN_DEVELOPMENT} url="/bep20-token-development" />
            <Banner
                priority={true}
                handleClickOpen={openForm}
                heading="BEP20 Token Development Company"
                subheading="Launch your BEP20 token on BNB Smart Chain with our end-to-end development services. We deliver secure, scalable, and high-performance tokens, empowering businesses to succeed in decentralized finance with confidence."
                button="Get Custom Quote"
                image={cdnImage('BEP-20/BEP20-Token-Development-Company.webp')}
                bannerClass="education-banner"
                // bannerBackground="new-home-banner-background"
                alt="BEP20 Token Development Company"
                DataPoints={bep20TokenBannerPoint}
            />
            <Box className="sub-banner-wrapper defi-banner-bottom-wrapper ">
                <MUIContainer>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between" className="white-label-bottom-container">
                        <Grid item md={2} lg={1.7} sm="auto" xs={12}>
                            <Typography className="banner-bottom-heading">Our Strategic Alliances</Typography>
                        </Grid>
                        {tokenCompanyBannerBottom?.map((data: any, index: number) => (
                            <Grid item sm="auto" xs={6} className="sub-banner-images" key={index + 1}>
                                <Box className="images-banner-bottom">
                                    <DisplayImage src={data.src} alt={data.alt} />
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </MUIContainer>
            </Box>
            <Grid item xs={12} className="bottom-margin top-space decording-main-wrapper">
                <MUIContainer>
                    <Decoding
                        imageSrc={driving}
                        alt="BEP20 Token Development: Driving Modern Business Success and Efficiency"
                        heading="BEP20 Token Development: Driving Modern Business Success and Efficiency"
                        subHeading={tokenCompanyDecodingData}
                        buttonText="Get Free Consultation"
                        openForm={openForm}
                    />
                </MUIContainer>
            </Grid>
            <Grid item xs={12} className="helper-section">
                <Box className="helper_section_parent bottom-spacing top-space">
                    <MUIContainer>
                        <Box className="spectrum-header-wrapper solutions">
                            <Typography className="spectrum-heading color-black " component="h2">
                                Tailored BEP20 Token Development Services We Offer for Your Business Needs
                            </Typography>
                            <Box className="divder-wrapper">
                                <hr className="divider-line" />
                            </Box>
                            <Box className="sub-heading-box" pb={4}>
                                <Typography className="spectrum-sub-heading color-black spacing">
                                    Our specialized BEP20 token development team delivers customized solutions designed to meet the specific
                                    needs of your business. Our services are crafted to help you leverage the full potential of BEP20 tokens
                                    in the evolving blockchain landscape.
                                </Typography>
                            </Box>
                        </Box>
                        <Grid container spacing={2}>
                            <HelperSection data={tokenDevelopmentData} className="home-helper-card" />
                        </Grid>
                    </MUIContainer>
                </Box>
            </Grid>
            <Box className="top-space mobile-top-padding ">
                <LatestCTA
                    heading="Transform Your Market with BEP20 Token Solutions"
                    subheading="Boost your brand with secure, scalable BEP20 token development tailored to maximize performance, adoption, and long-term growth."
                    buttonText="Get Started Today"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12} className="blockchain-revolution-service bottom-spacing top-space">
                <MUIContainer>
                    <Platforms
                        data={tokenCompanyFeatureContent}
                        heading="Exceptional Features of Our BEP-20 Token Development Solutions"
                        subheading="Our team specializes in embedding critical features into BEP-20 token solutions, enhancing both functionality and security for your projects on the BNB Chain. Each feature is meticulously integrated to ensure optimal performance and strategic advantage. Here are the key features included:"
                        containerClass="blockchain-card-container"
                        className="defi-feature-platform-service"
                    />
                </MUIContainer>
            </Grid>
            <Grid item xs={12} className="helper-section">
                <Box className="helper_section_parent bottom-spacing top-space">
                    <Grid container spacing={2} className="our-service-defi-wrapper">
                        <OurServices
                            ourServices={keyBenefitTokenDevelopmentContent}
                            className="service-shadow-border-box enterprise-key-card"
                            containerClass="card-heading-spacing"
                            heading="Key Advantages of Our Expert BEP-20 Token Development Solutions"
                            subheading="As a premier BEP20 token development company, we focus on enhancing business operations through specialized BEP20 token development services. Our advanced BEP20 token solutions are designed to maximize the potential of blockchain technology, ensuring transformative results for enterprises on the BNB Smart Chain. Partnering with us allows you to harness the full capabilities of BEP20 token development for significant market engagement and operational efficiency."
                        />
                    </Grid>
                </Box>
            </Grid>
            <Box className="helper_section_parent bottom-spacing  mobile-bottom-padding">
                <LatestCTA
                    heading="Propel Your Enterprise with BEP20 Tokens"
                    subheading="Leverage expert token solutions that strengthen business operations, streamline fundraising, and enhance visibility across the blockchain ecosystem."
                    buttonText="Talk to Our Experts"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12} className="dynmaic-white-label-wrapper top-space bottom-margin dynamic-bep20-wrapper">
                <MUIContainer>
                    <Box className="spectrum-header-wrapper solutions">
                        <Typography className="spectrum-heading color-black " component="h2">
                            Explore Our Exclusive Token Development Portfolio
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line" />
                        </Box>
                    </Box>
                    <DynamicScreens
                        imageSrc={genius}
                        subHeading="TokenGenius Platform"
                        heading="Streamlining Token Development & ICO Launches"
                        subPoints={TokenGeniusData}
                        reverseOrder={true}
                        alt="TokenGenius Platform"
                        checkItems={TokenGeniusCheckPoints}
                        openForm={openForm}
                        buttonData={TokenGeniusScreenButton}
                    />
                    <DynamicScreens
                        imageSrc={tokenCraft}
                        subHeading="TokenCraft Platform"
                        heading="Empowering ICO Campaigns with Transparency & Compliance"
                        subPoints={TokenCraftData}
                        reverseOrder={false}
                        alt="TokenCraft Platform"
                        checkItems={TokenCraftCheckPoints}
                        openForm={openForm}
                        buttonData={TokenCraftScreenButton}
                    />
                    <DynamicScreens
                        imageSrc={nftGenius}
                        subHeading="NFTGenius Platform"
                        heading="Revolutionizing NFT Creation & Marketplace Experience"
                        subPoints={NFTGeniusData}
                        reverseOrder={true}
                        alt="NFTGenius Platform"
                        checkItems={NFTGeniusCheckPoints}
                        openForm={openForm}
                        buttonData={NFTGeniusScreenButton}
                    />
                </MUIContainer>
            </Grid>

            <Grid item xs={12} className="helper-section">
                <Box className="helper_section_parent bottom-spacing top-space">
                    <MUIContainer>
                        <Box className="spectrum-header-wrapper solutions">
                            <Typography className="spectrum-heading color-black " component="h2">
                                Diverse Use Cases of BEP20 Token Development for Business Growth
                            </Typography>
                            <Box className="divder-wrapper">
                                <hr className="divider-line" />
                            </Box>
                            <Box className="sub-heading-box" pb={4}>
                                <Typography className="spectrum-sub-heading color-black spacing">
                                    As a leading BEP20 token development company, we empower businesses across various industries to
                                    leverage the full potential of blockchain technology. Our expertise in creating and deploying BEP20
                                    tokens helps you unlock new avenues for growth, efficiency, and market expansion.
                                </Typography>
                            </Box>
                        </Box>
                        <Grid container spacing={2}>
                            <HelperSection data={diverseTokenContent} className="home-helper-card" />
                        </Grid>
                    </MUIContainer>
                </Box>
            </Grid>
            <Box className="top-space mobile-top-padding">
                <LatestCTA
                    heading="Drive Innovation with BEP20 Token Use Cases"
                    subheading="Unlock new opportunities by applying BEP20 tokens across industries with custom blockchain solutions built for scalability and compliance."
                    buttonText="Hire Blockchain Developers"
                    openForm="/hire-blockchain-developers"
                    className="blue-background-cta"
                    meetingLink={true}
                />
            </Box>
            <Grid item xs={12} className="blockchain-revolution-service bottom-spacing top-space">
                <MUIContainer>
                    <Platforms
                        data={diverseTokenDevelopment}
                        heading="Diverse BEP-20 Tokens We Develop at Our BNB Chain Token Development Agency"
                        subheading="At our BNB Chain development agency, we specialize in creating a wide range of BEP-20 tokens tailored to meet diverse business needs. Our experienced team ensures that each token type serves a specific purpose, enhancing the functionality and reach of your blockchain projects."
                        containerClass="blockchain-card-container"
                        className="defi-feature-platform-service"
                    />
                </MUIContainer>
            </Grid>
            <Grid item xs={12} className="helper-section">
                <Box className="helper_section_parent bottom-spacing top-space">
                    <Grid container spacing={2} className="our-service-defi-wrapper">
                        <OurServices
                            ourServices={featureDevelopmentContent}
                            className="service-shadow-border-box feature-bep20-card"
                            containerClass="spectrum-btn"
                            heading="Advanced Features of Our BEP20 Token Developments"
                            subheading="Our BEP20 token development services are designed with advanced features that ensure your tokens are secure, scalable, and aligned with the evolving needs of your project. Here’s a look at the innovative features we can integrate into your BEP20 tokens:"
                        />
                    </Grid>
                </Box>
            </Grid>
            <Box className=" helper_section_parent bottom-spacing  mobile-bottom-padding">
                <LatestCTA
                    heading="Want To Launch Your Token on BNB Chain?"
                    subheading="Fast-track your token journey with secure deployment, exchange listing, and strategic guidance to achieve business transformation."
                    buttonText="Schedule a Consultation Now"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Box className="bottom-spacing mobile-bottom-padding">
                <MUIContainer>
                    <TokenizeHelp
                        heading="Industries We Empower with Advanced BEP-20 Token Development Solutions"
                        subheading="Our BSC token development firm offers comprehensive BEP-20 token services across various industries, helping businesses leverage blockchain technology to expand their reach, enhance user engagement, and drive innovation."
                        contentData={bep20IndustryData}
                    />
                </MUIContainer>
            </Box>
            <Grid
                item
                xs={12}
                className="bottom-spacing generative-tech-wrapper mobile-bottom-padding top-space mobile-top-padding helper_section_parent"
            >
                <CardTechnology
                    heading="Advanced Technology Stack We Utilize For BEP20 Token Development"
                    subheading="We leverage a secure, scalable, and enterprise-grade technology stack to develop BEP20 tokens that deliver high performance, security, and interoperability. Our toolkit covers blockchain protocols, token standards, smart contracts, front-end and back-end frameworks, cloud infrastructure, and DevOps tools essential for robust, market-ready token solutions."
                    data={bep20TokenTechnologyData}
                />
            </Grid>
            <Box className=" helper_section_parent bottom-spacing  mobile-bottom-padding">
                <LatestCTA
                    heading="Looking to Lead Industry with BEP-20 Token?"
                    subheading="Partner with a blockchain development company to design secure, high-performance BEP20 tokens that give your enterprise a competitive advantage."
                    buttonText="Let’s Get Started"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Box className="bottom-spacing process-mobile-bottom-padding top-space mobile-top-padding">
                <MUIContainer>
                    <Box className="spectrum-header-wrapper solutions">
                        <Typography className="spectrum-heading color-black text-align-left" component="h2">
                            Our Step-by-Step Process for BEP-20 Token Development Success
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line divider-line-left" />
                        </Box>
                        <Box className="sub-heading-box" pb={4}>
                            <Typography className="spectrum-sub-heading color-black spacing text-align-left" component="p">
                                Our experienced team follows a meticulously crafted process to ensure the successful creation and deployment
                                of your BEP20 token. From selecting the right blockchain platform to launching your token on the Binance
                                Smart Chain, we handle every detail with precision and expertise. Here’s how we bring your BEP20 token
                                vision to life:
                            </Typography>
                        </Box>
                    </Box>
                    <Box textAlign="center">
                        <DisplayImage src={development} alt="Enterprise‑Grade Solutions" className="approach-main-img approach-web-img" />
                    </Box>
                    <Box className="approach-main-img approach-mobile-img">
                        <MobileProcess mobileProcess={bep20TokenMobileProcess} />
                    </Box>
                </MUIContainer>
            </Box>
            <OurMakeChoice
                heading="Why Debut Infotech Leads"
                subheading="in BEP20 Token Development Services?"
                body={bep20TokenChooseBody}
                contentData={bep20TokenChooseContent}
            />
            <Grid item xs={12}>
                <LetDiscuss
                    heading="Ready to Scale Business with BEP-20 Tokens?"
                    subheading="Transform your business with our expert BEP-20 token development. Get customized solutions and strategic insights tailored for success in the digital economy."
                    btnLabel="Contact Us Now"
                    openForm={openForm}
                />
            </Grid>
            <Grid item xs={12} className="question-parent margin top-space mobile-top-padding">
                <MUIContainer>
                    <Questions accordianData={tokenCompanyFAQData} />
                </MUIContainer>
            </Grid>
            <Grid item xs={12}>
                <Box className="top-space mobile-top-padding bg-blue-background">
                    <Testimonials heading="Client Testimonials" clientData={tokenDevelopmentCarsoulData} />
                </Box>
            </Grid>
            <script
                id="app-id-json"
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org/',
                        '@type': 'Product',
                        name: 'Bep20 Token Development',
                        image: `${CDN_URL}?url=%2Fimages%2FBEP-20%2FBEP20-Token-Development-Company.webp&w=750&q=75`,
                        description:
                            'Create secure and scalable BEP20 tokens on the Binance Smart Chain with our expert development services, tailored for seamless integration and enhanced functionality.',
                        brand: {
                            '@type': 'Brand',
                            name: 'Debut Infotech'
                        },
                        offers: {
                            '@type': 'AggregateOffer',
                            url: `${SITE_URL}/bep20-token-development`,
                            priceCurrency: 'USD',
                            lowPrice: '500',
                            highPrice: '2000'
                        },
                        aggregateRating: {
                            '@type': 'AggregateRating',
                            ratingValue: '4.7',
                            bestRating: '5',
                            worstRating: '1',
                            ratingCount: '399'
                        }
                    })
                }}
            />
            <script
                type="application/ld+json"
                id="bep20-token-development"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'FAQPage',
                        mainEntity: [
                            {
                                '@type': 'Question',
                                name: 'What is a BEP20 token?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'A BEP20 token is a type of digital asset created on the Binance Smart Chain (BSC) that adheres to the BEP20 token standard. It defines a set of rules for the creation and interaction of tokens on the BSC network. Our BEP20 token development services ensure that your BEP20 token meets these standards for optimal performance and compatibility.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What is the Binance Smart Chain?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'The Binance Smart Chain (BSC) is a blockchain network that runs in parallel with Binance Chain. It supports smart contracts and decentralized applications (dApps), providing a scalable and cost-effective platform. Our BEP20 token development company utilizes BSC to create and deploy BEP20 tokens efficiently.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Why choose BEP20 tokens over other standards?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'BEP20 tokens offer several advantages, including lower transaction fees and faster transaction speeds compared to other standards like ERC20. Choosing BEP20 tokens allows for seamless integration with the Binance Smart Chain ecosystem and benefits from its robust security features. Our BEP20 token development services help you leverage these advantages for your projects.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How long does it take to develop a BEP20 token?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'The development time for a BEP20 token varies depending on the complexity of the project and the specific requirements. On average, it takes a few weeks to develop and deploy a BEP20 token. Our BEP20 token development company ensures a streamlined process to meet your deadlines efficiently.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Can BEP20 tokens be used for fundraising?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Yes, BEP20 tokens can be effectively used for fundraising through methods like Initial Coin Offerings (ICOs) or token sales. Our BEP20 token generator and development services can help you create BEP20 tokens specifically designed for these fundraising activities.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Can BEP20 tokens be used for cross-chain transactions?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'BEP20 tokens are primarily designed for use within the Binance Smart Chain ecosystem. However, with the right protocols and bridges, they can facilitate cross-chain transactions. Our team can guide you through the process of setting up your BEP20 tokens for such functionalities.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What is the Difference Between BEP20 and ERC20?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'BEP20 and ERC20 are token standards used on different blockchains—BSC and Ethereum, respectively. BEP20 tokens are known for their lower transaction fees and faster processing times compared to ERC20 tokens, which are known for their extensive adoption and established ecosystem. Our BEP20 token development services ensure that your tokens are optimized for the BSC environment.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What do I need to develop a BEP20 token?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: "To create a BEP20 token, you'll need a clear idea of the token's specifications, such as total supply, name, and symbol. Additionally, you'll require a Binance Smart Chain wallet and a BEP20 token generator to deploy the token. Our BEP20 token development company provides comprehensive support for all these requirements."
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How do BEP-20 tokens differ from ERC-20 tokens?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: "BEP-20 tokens are based on the Binance Smart Chain, while ERC-20 tokens operate on the Ethereum blockchain. BEP-20 tokens benefit from lower transaction fees and faster speeds, while ERC-20 tokens offer greater network security and wider adoption. Our BEP20 token development services can help you navigate these differences based on your project's needs."
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Are BEP20 tokens compatible with all wallets?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'BEP20 tokens are compatible with wallets that support Binance Smart Chain, such as Trust Wallet and MetaMask. They may not be compatible with wallets designed exclusively for Ethereum-based tokens. Our BEP20 token development company can ensure compatibility with a range of wallets to maximize accessibility.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How much does it cost to develop a BEP20 token?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: "The cost of developing a BEP20 token depends on various factors, including the complexity of the token's features and the scope of the project. Our BEP20 token development services provide tailored pricing based on your specific requirements to ensure you get the best value."
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Why Choose Debut Infotech as your BEP20 Token Development Company?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Debut Infotech offers specialized BEP20 token development services with a focus on delivering high-quality, secure, and efficient tokens. Our experienced team uses cutting-edge technology and a client-centric approach to ensure your BEP20 tokens meet your business needs and exceed your expectations.'
                                }
                            }
                        ]
                    })
                }}
            />
        </Box>
    );
};

export default TokenDevelopment;
TokenDevelopment.Layout = 'Main';
